export const ALLOWED_CERTIFICATE_FILE_EXTENSION = 'p12'; // exclude the dot, i.e. not '.p12'

// This needs to stay up to date with the `CertificateType` PHP enum.
export const CertificateType = Object.freeze({
    Encryption: 1,
    Signature: 2,
});

// This needs to stay up to date with the `CertificateIconType` PHP enum.
export const CertificateIconType = Object.freeze({
    Current: 1,
    Expired: 2,
    Disabled: 3,
    Warning: 4,
    WillNotUse: 5,
});

// This needs to stay up to date with the `AddressType` PHP enum.
export const AddressType = Object.freeze({
    ResidentalAddress: 0, //TODO(Bernt) update when typo is fixed in EDI service
    NationalRegisteredAddress: 1,
    HolidayAddress: 2,
    BillingAddress: 3,
    PostalAddress: 4,
    VisitingAddress: 5,
    TemporaryAddress: 6,
    WorkAddress: 7,
});

// This needs to stay up to date with the `ElectronicContactInfoType` PHP enum.
export const ElectronicContactInfoType = Object.freeze({
    NotSpecified: 0,
    Fax: 1,
    Telephone: 2,
    Email: 3,
    Central: 4,
    WebsiteUrl: 5,
});

// This needs to stay in sync with MessageBoxType PHP enum.
export const MessageBoxType = Object.freeze({
    None: 0,
    Inbox: 1,
    Outbox: 2,
    Archive: 3,
});

// This needs to stay in sync with MessageType PHP enum.
export const MessageType = Object.freeze({
    Unknown: 0,
    RequestMessage: 1,
    RequestReplyMessage: 2,
    DeviationMessage: 3,
    RequestMessage_nav: 4,
    ReplyMessage_nav: 5,
    RequestReplyMessage_nav: 6,
    HelfoSettlement: 7,
    AppRec: 8,
    TransportReciept: 9,
    Note: 10,
    RadiologyRequisition: 11,
    Cppa: 12,
    RadiologyReply: 13,
    HelfoFreecardRequest: 14,
    ReferralForward: 15,
    ReferralNewState: 16,
    Epicrisis: 17,
    ReferralStatusMessage: 18,
    DoctorsDeclaration: 19,
    SickLeave: 20,
    InquiryToNav: 21,
    Referral: 24,
});

// This needs to stay in sync with MessageFilter PHP enum.
export const MessageFilter = Object.freeze({
    All : 0,
    Unread : 1,
    Warning : 2,
    Failed : 3,
    Draft: 4,
    NonDraft: 5,
});

// This needs to stay in sync with the LogSeverity PHP enum.
export const LogSeverity = Object.freeze({
    Trace: 0,
    Info: 1,
    Warning: 2,
    Error: 3,
});

// This needs to stay in sync with the SearchMode PHP enum.
export const SearchMode = Object.freeze({
    ImportMode: 0,
    EdiSenderMode: 1,
    EdiRecipientMode: 2,
});

// This needs to stay in sync with the MessageStatus PHP enum.
export const MessageStatus = Object.freeze({
    Processing: 0,
    Draft: 1,
    NotAcknlowledged: 2,
    Ok: 3,
    Warning: 4,
    Error: 5,
    SecurityError: 6,
});

// This needs to stay in sync with the ProfessionType PHP enum.
export const ProfessionType = Object.freeze({
    Unspecified: 0,
    Doctor: 1,
    Psychologist: 2,
    Nurse: 3,
    Physiotherapist: 4,
    Manual_Therapist: 5,
    Chiropractor: 6,
    Orthoptist: 7,
    Podiatrist: 8,
    Occupational_Therapist: 9,
    Psychiatrist :10,
    Audiopedagogue :11,
    Speech_Therapist :12,
});

// This needs to stay in sync with the mapOccupationToProfessionType in app\User.php
export const ProfessionTypeMapping = Object.freeze({
    'other': ProfessionType.Unspecified,
    'doctor': ProfessionType.Doctor,
    'psychologist': ProfessionType.Psychologist,
    'nurse': ProfessionType.Nurse,
    'physiotherapist': ProfessionType.Physiotherapist,
    'manual-therapist': ProfessionType.Manual_Therapist,
    'chiropractor': ProfessionType.Chiropractor,
    'orthoptist': ProfessionType.Orthoptist,
    'chiropodist': ProfessionType.Podiatrist,
    'occupational-therapist': ProfessionType.Occupational_Therapist,
    'psychiatrist': ProfessionType.Psychiatrist,
    'audiopedagogue': ProfessionType.Audiopedagogue,
    'speech-therapist': ProfessionType.Speech_Therapist,
});

// This needs to stay in sync with the CompartyType PHP enum.
export const CompartyType = Object.freeze({
    Organization: 1,
    Department: 2,
    OrganizationPerson: 3,
    Service: 4,
    None: 5,
});

// This needs to stay up to date with Sex PHP enum.
export const Sex = Object.freeze({
    Unknown: 0,
    Male: 1,
    Female: 2,
    Unspecified: 9,
});

// This needs to stay up to date with SocialSecurityNumberType PHP enum.
export const SocialSecurityNumberType = Object.freeze({
    Standard: 0, // Fødselsnummer
    Temporary: 1, // D-nummer
    LocalHelpNumber: 2, // H-nummer
    CommonHelpNumber: 3, // FH-nummer
});

// This needs to stay up to date with the `AttachmentType` PHP enum.
export const MessageAttachmentType = Object.freeze({
    Upload: 'UPLOAD',
    JournalFile: 'JOURNAL_FILE',
    Document: 'DOCUMENT',
});

// This needs to stay up to date with the RadiologyType PHP enum.
export const RadiologyTypeCodes = Object.freeze({
    PaymentCategory: 4101,
    MRInformation: 8209,
    Gyno: 8217,
    MRContraindications: 8210,
    RequestMessage: 8202,
});

export const DiagnosesSystemCodes = Object.freeze({
    ICD10: '2.16.578.1.12.4.1.1.7110',
    ICD10BUP: '2.16.578.1.12.4.1.1.7112',
    ICPC2: '2.16.578.1.12.4.1.1.7170',
});

// This needs to stay up to date with the ManualAdditionalFields PHP enum.
export const ManualAdditionalFields = Object.freeze({
    ReferralPatientRelatedContactPerson: 1,
    ReferralAdditionalInformationOnPatient: 2,
    ReferralNextOfKinGuardian: 3,
    ReferralAssociatedUnit: 4,
    ReferralInfoAssistedCommunication: 5,
    ReferralInformationAboutIndividualPlan: 6,
    ReferralSendDocument: 7,
    ReferralForwardEvaluationOfReferral: 8,
});

export const IdentityType = {
    Unspecified: 0,
    FNR: 1,
    DNR: 2,
    HPR: 3,
    HerId: 4,
};